module.exports = __webpack_public_path__ + "static/media/howitwork.8de1cf4a.png";